<template>
    <div class="transactions-page">
        <SectionHeader :icon="`icon-transactions`">
            {{$t('history') | upperCase}}
        </SectionHeader>
        <div class="transactions-container">
            <div
                v-for="(item, index) in items"
                :key="index"
                class="transactions-type"
            >
                <h2 class="section-title">{{ $t(item.title) | capitalize }}</h2>
                <div class="notice">{{ $t(item.description) | capitalize }}</div>
                <div @click="showTransactions(item.type)">
                    <SubtleLink :link="{}">
                        {{ $t('show all transactions') | capitalize }}
                    </SubtleLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { HistoryType } from '@store/modules/ui/user/history/enums';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import config from '@config';

    export default {
        name: 'HistoryContainer',
        data() {
            return {
                items: [
                    {
                        type: HistoryType.transactions,
                        description: 'here you can track the history of all deposit and withdrawal transactions',
                        title: 'transactions history',
                    },
                    {
                        type: HistoryType.bets,
                        description: 'here you can track the history of all sport and lotto bets',
                        title: 'bets history',
                    },
                    {
                        type: HistoryType.casinoPlays,
                        description: 'here you can track the history of all casino plays',
                        title: 'casino history'
                    },
                ].filter((item) => config.countrySpecific.user.history.availableTypes[item.type])
            };
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            showTransactions(type) {
                const title = {
                    [HistoryType.transactions]: 'transactions history',
                    [HistoryType.bets]: 'bets history',
                    [HistoryType.casinoPlays]: 'casino history',
                }[type];

                const currencyDisplay = {
                    [HistoryType.transactions]: 'cutoff',
                    [HistoryType.bets]: 'round',
                    [HistoryType.casinoPlays]: 'round',
                }[type];

                this.setModal({
                    title,
                    code: Modals.transactionHistory.code,
                    data: {
                        type,
                        currencyDisplay,
                    }
                });
            },
        },
        components: {
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/history/HistoryContainer.vue